import { render, staticRenderFns } from "./Foundaddress.vue?vue&type=template&id=50286656&scoped=true"
import script from "./Foundaddress.vue?vue&type=script&lang=js"
export * from "./Foundaddress.vue?vue&type=script&lang=js"
import style0 from "./Foundaddress.vue?vue&type=style&index=0&id=50286656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50286656",
  null
  
)

export default component.exports